/**
* Vertical Tabs JS
* -----------------------------------------------------------------------------
*
* All the JS for the Vertical Tabs component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'vertical-tabs',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      /*       $( '.vertical-tabs__item' ).on( 'click', function() {
        if ( window.matchMedia( '(min-width: 1024px)' ).matches ) {
          $( this ).closest( '.vertical-tabs' ).find( '.vertical-tabs__item' ).removeClass( 'active' );
          $( this ).addClass( 'active' );
        }
      } ); */
      $( '.vertical-tab__item-title' ).on( 'toggleAfter', ( event ) => {
        $( event.target ).next().slideToggle();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'vertical-tabs', COMPONENT );
} )( app );
